import React, { useState, useEffect } from 'react'
import ImageSprite from '../icons-5.svg'
import IconEngyj from '../icon-engyj-app.svg'

function WidgetContent(){

    const initialStateScreenRead        = (localStorage.getItem('setStateScreenRead'))       ? localStorage.getItem('setStateScreenRead')       : 'position0'
    const initialStateContrast          = (localStorage.getItem('setStateContrast'))         ? localStorage.getItem('setStateContrast')         : 'position0'
    const initialStateSmartContrast     = (localStorage.getItem('setStateSmartContrast'))    ? localStorage.getItem('setStateSmartContrast')    : 'position0'
    const initialStateHighlightLinks    = (localStorage.getItem('setStateHighlightLinks'))   ? localStorage.getItem('setStateHighlightLinks')   : 'position0'
    const initialStateBiggerText        = (localStorage.getItem('setStateBiggerText'))       ? localStorage.getItem('setStateBiggerText')       : 'position0'
    const initialStateTextSpacing       = (localStorage.getItem('setStateTextSpacing'))      ? localStorage.getItem('setStateTextSpacing')      : 'position0'
    const initialStatePauseAnimation    = (localStorage.getItem('setStatePauseAnimation'))   ? localStorage.getItem('setStatePauseAnimation')   : 'position0'
    const initialStateDyslexiaFriendly  = (localStorage.getItem('setStateDyslexiaFriendly')) ? localStorage.getItem('setStateDyslexiaFriendly') : 'position0'
    const initialStateCursor            = (localStorage.getItem('setStateCursor'))           ? localStorage.getItem('setStateCursor')           : 'position0'
    const initialStateTooltips          = (localStorage.getItem('setStateTooltips'))         ? localStorage.getItem('setStateTooltips')         : 'position0'
    const initialStatePageStructure     = (localStorage.getItem('setStatePageStructure'))    ? localStorage.getItem('setStatePageStructure')    : 'position0'
    const initialStateLineHeight        = (localStorage.getItem('setStateLineHeight'))       ? localStorage.getItem('setStateLineHeight')       : 'position0'
    const initialStateTextAlign         = (localStorage.getItem('setStateTextAlign'))        ? localStorage.getItem('setStateTextAlign')        : 'position0'
    const initialStateReadingFlow       = (localStorage.getItem('setStateReadingFlow'))      ? localStorage.getItem('setStateReadingFlow')      : 'position0'
    const initialStateMoveHideIcon      = (localStorage.getItem('setStateMoveHideIcon'))     ? localStorage.getItem('setStateMoveHideIcon')     : 'position0'

    const [stateScreenRead, setStateScreenRead]             = useState(initialStateScreenRead)
    const [stateContrast, setStateContrast]                 = useState(initialStateContrast)
    const [stateSmartContrast, setStateSmartContrast]       = useState(initialStateSmartContrast)
    const [stateHighlightLinks, setStateHighlightLinks]     = useState(initialStateHighlightLinks)
    const [stateBiggerText, setStateBiggerText]             = useState(initialStateBiggerText)
    const [stateTextSpacing, setStateTextSpacing]           = useState(initialStateTextSpacing)
    const [statePauseAnimation, setStatePauseAnimation]     = useState(initialStatePauseAnimation)
    const [stateDyslexiaFriendly, setStateDyslexiaFriendly] = useState(initialStateDyslexiaFriendly)
    const [stateCursor, setStateCursor]                     = useState(initialStateCursor)
    const [stateTooltips, setStateTooltips]                 = useState(initialStateTooltips)
    const [statePageStructure, setStatePageStructure]       = useState(initialStatePageStructure)
    const [stateLineHeight, setStateLineHeight]             = useState(initialStateLineHeight)
    const [stateTextAlign, setStateTextAlign]               = useState(initialStateTextAlign)
    const [stateReadingFlow, setStateReadingFlow]           = useState(initialStateReadingFlow)
    const [stateMoveHideIcon, setStateMoveHideIcon]         = useState(initialStateMoveHideIcon)
    
    useEffect(() => {

        if(stateContrast === 'position0') contrastLevel0()
        if(stateContrast === 'position1') contrastLevel1()
        if(stateContrast === 'position2') contrastLevel2()
        if(stateContrast === 'position3') contrastLevel3()
        if(stateContrast === 'position4') contrastLevel4()

        if(stateHighlightLinks === 'position0') HighlightLinksLevel0()
        if(stateHighlightLinks === 'position1') HighlightLinksLevel1()
        
        if(stateBiggerText === 'position0') BiggerTextLevel0()
        if(stateBiggerText === 'position1') BiggerTextLevel1()
        if(stateBiggerText === 'position2') BiggerTextLevel2()
        if(stateBiggerText === 'position3') BiggerTextLevel3()
        if(stateBiggerText === 'position4') BiggerTextLevel4()
        
        if(stateTextSpacing === 'position0') TextSpacingLevel0()
        if(stateTextSpacing === 'position1') TextSpacingLevel1()
        if(stateTextSpacing === 'position2') TextSpacingLevel2()
        if(stateTextSpacing === 'position3') TextSpacingLevel3()
        
        if(statePauseAnimation === 'position0') PauseAnimationLevel0()
        if(statePauseAnimation === 'position1') PauseAnimationLevel1()
        
        if(stateDyslexiaFriendly === 'position0') DyslexiaFriendlyLevel0()
        if(stateDyslexiaFriendly === 'position1') DyslexiaFriendlyLevel1()
        if(stateDyslexiaFriendly === 'position2') DyslexiaFriendlyLevel2()

        if(stateCursor === 'position0') CursorLevel0()
        if(stateCursor === 'position1') CursorLevel1()
        if(stateCursor === 'position2') CursorLevel2()
        if(stateCursor === 'position3') CursorLevel3()

        if(stateLineHeight === 'position0') LineHeightLevel0()
        if(stateLineHeight === 'position1') LineHeightLevel1()
        if(stateLineHeight === 'position2') LineHeightLevel2()
        if(stateLineHeight === 'position3') LineHeightLevel3()

        if(stateTextAlign === 'position0') TextAlignLevel0()
        if(stateTextAlign === 'position1') TextAlignLevel1()
        if(stateTextAlign === 'position2') TextAlignLevel2()
        if(stateTextAlign === 'position3') TextAlignLevel3()
        if(stateTextAlign === 'position4') TextAlignLevel4()

        if(stateMoveHideIcon === 'position0') MoveHideIconLevel0()
        if(stateMoveHideIcon === 'position1') MoveHideIconLevel1()

    })
        
    
    let html            = document.getElementsByTagName('html')[0]
    let body            = document.getElementsByTagName('body')[0]
    let webBody         = document.querySelectorAll('body *:not(div#engyjChatWidgetRoot *)')
    let webBodyAnchor   = document.querySelectorAll('body a:not(div#engyjChatWidgetRoot a)')
    let divs            = document.querySelectorAll('div:not(div#engyjChatWidgetRoot div)')
    let allWebElement   = document.querySelectorAll('*:not(div#engyjChatWidgetRoot div')
    let WebMaindiv      = document.querySelectorAll('body > *:not(div#engyjChatWidgetRoot)')
    let widgetWrapper   = document.getElementById('engyjChatWidgetRoot')

    /*========================
     Helper Functions
    ======================*/
    
    function helperFilterTextElementAndApplyStyle(ele, eleclass, inlineStyle){
        
        if ( ele.nodeType === Node.TEXT_NODE && ele.nodeValue.trim()){
            if(eleclass){
                ele.parentNode.classList += eleclass
            }
            
            if(inlineStyle){
                Object.keys(inlineStyle).forEach(function(key){
                    ele.parentNode.style[key] = inlineStyle[key]
                })

            }

        }
        
        ele.childNodes.length && ele.childNodes.forEach(e => helperFilterTextElementAndApplyStyle(e, eleclass, inlineStyle))

        widgetWrapper.classList = 'noStyle';
    }

    function helperFocusLinks(ele, inlineStyle){
        
        if(inlineStyle){
            Object.keys(inlineStyle).forEach(function(key){
                for (var i = 0; i < ele.length; i++) {
                    ele[i].style[key] = inlineStyle[key]
                }
            })
        }

    }

    function helperContrast(ele, inlineStyle){
        
        if(inlineStyle){
            Object.keys(inlineStyle).forEach(function(key){
                for (var i = 0; i < ele.length; i++) {
                    ele[i].style[key] = inlineStyle[key]
                }
            })
        }

    }

    function helperBiggerText(ele, inlineStyle){
        
        if(inlineStyle){
            Object.keys(inlineStyle).forEach(function(key){
                for (var i = 0; i < ele.length; i++) {
                    ele[i].style[key] = inlineStyle[key]
                }
            })
        }

    }

    function helperUndoAll(){

        html.classList.remove(
            'ContrastPosition0',
            'ContrastPosition1',
            'ContrastPosition2',
            'ContrastPosition3',
            'ContrastPosition4',
            'MoveHidePosition1',
            'engyj-big-cursor',
            'animation-stop'
            
        )
        body.classList.remove(
            'engyj-big-cursor',
            'animation-stop'
            )

        const undoFocusLinks = { backgroundColor : "", color : "", textDecoration : "" }
        const undoStylingBiggerText = { zoom: 'inherit' }
        const undoStylingFilterTextElementAndApply = { fontFamily: "", lineHeight: "", textAlign: "" }
        const undoContraststyling = { backgroundColor: "", borderColor: "", color: "" }
        
        helperFocusLinks(webBodyAnchor, undoFocusLinks)
        helperBiggerText(WebMaindiv, undoStylingBiggerText)
        helperContrast(divs, undoContraststyling)

        for(let i=0; i < webBody.length; i++) helperFilterTextElementAndApplyStyle(webBody[i], ' engyj-letter-spacing-0', undoStylingFilterTextElementAndApply)

        let a = document.querySelector('.engyj-exception.top')
        let b = document.querySelector('.engyj-exception.bottom')
        let c = document.querySelector('.engyj-cursor-level3')
        let d = document.querySelector('.moveText')
        
        if(document.body.contains(a)) a.remove()
        if(document.body.contains(b)) b.remove()
        if(document.body.contains(c)) c.remove()
        
        if(document.body.contains(d)) d.textContent = 'Move Left'
        // contrastLevel0()
        // HighlightLinksLevel0()
        // BiggerTextLevel0()
        // TextSpacingLevel0()
        // PauseAnimationLevel0()
        // DyslexiaFriendlyLevel0()
        // CursorLevel0()
        // LineHeightLevel0()
        // TextAlignLevel0()
        // MoveHideIconLevel0()
    }


    /*========================
      Operation Functions
    ======================*/

    /*------------------------
      Contrast Operations
    -------------------------*/
    function contrastLevel0(){
        html.classList.remove('ContrastPosition4')
    }
    function contrastLevel1(){
        html.classList += ' ContrastPosition1'
    }
    function contrastLevel2(){
        html.classList.remove('ContrastPosition1')
        html.classList += ' ContrastPosition2'

        const styling = {
            backgroundColor: "#000",
            borderColor: "#fff",
            color: "#50d0a0"
        }
        // helperFilterTextElementAndApplyStyle(body, '', styling)
        helperContrast(divs, styling)
        // widgetWrapper.style = ""
    }
    function contrastLevel3(){
        html.classList.remove('ContrastPosition2')
        html.classList += ' ContrastPosition3'

        const styling = {
            backgroundColor: "#fff",
            borderColor: "#000",
            color: "#000"
        }
        // helperFilterTextElementAndApplyStyle(body, '', styling)
        helperContrast(divs, styling)
        // widgetWrapper.style = ""
    }
    function contrastLevel4(){
        html.classList.remove('ContrastPosition3')
        html.classList += ' ContrastPosition4'

        const styling = {
            backgroundColor: "",
            borderColor: "",
            color: ""
        }
        // helperFilterTextElementAndApplyStyle(body, '', styling)
        helperContrast(divs, styling)
    }

    /*----------------------------
      Highlight Links Operations
    -----------------------------*/
    function HighlightLinksLevel0(){
        const styling = {
            backgroundColor : "",
            color : "",
            textDecoration : ""
        }
        helperFocusLinks(webBodyAnchor, styling)
    }
    function HighlightLinksLevel1(){
        const styling = {
            backgroundColor : "#000",
            color : "yellow",
            textDecoration : "underline"
        }
        helperFocusLinks(webBodyAnchor, styling)
    }

    /*----------------------------
      Bigger Text Operations
    -----------------------------*/
    function BiggerTextLevel0(){
        const styling = {
            zoom: 'inherit'
        }
        helperBiggerText(WebMaindiv, styling)
        // console.log(WebMaindiv.length);
        // WebMaindiv.style.zoom = 'inherit'
    }
    function BiggerTextLevel1(){
        const styling = {
            zoom: 1.2
        }
        helperBiggerText(WebMaindiv, styling)
        // console.log(WebMaindiv.length)
        // WebMaindiv.style.zoom = 1.2
    }
    function BiggerTextLevel2(){
        const styling = {
            zoom: 1.3
        }
        helperBiggerText(WebMaindiv, styling)
        // console.log(WebMaindiv.length);
        // WebMaindiv.style.zoom = 1.3
    }
    function BiggerTextLevel3(){
        const styling = {
            zoom: 1.4
        }
        helperBiggerText(WebMaindiv, styling)
        // WebMaindiv.style.zoom = 1.4
    }
    function BiggerTextLevel4(){
        const styling = {
            zoom: 1.5
        }
        helperBiggerText(WebMaindiv, styling)
        // console.log(WebMaindiv.length);
        // WebMaindiv.style.zoom = 1.5
    }

    /*----------------------------
      Text Spacing Operations
    -----------------------------*/
    function TextSpacingLevel0(){
        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], ' engyj-letter-spacing-0')
        }
    }
    function TextSpacingLevel1(){
        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], ' engyj-letter-spacing-1')
        }
    }
    function TextSpacingLevel2(){
        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], ' engyj-letter-spacing-2')
        }
    }
    function TextSpacingLevel3(){
        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], ' engyj-letter-spacing-3')
        }
    }

    /*----------------------------
      Pause Animation Operations
    -----------------------------*/
    function PauseAnimationLevel0(){
        body.classList.remove('animation-stop')
    }
    function PauseAnimationLevel1(){
        body.classList += " animation-stop"
    }

    /*------------------------------
      Dyslexia Friendly Operations
    --------------------------------*/
    function DyslexiaFriendlyLevel0(){
        const styling = {
            fontFamily: ''
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function DyslexiaFriendlyLevel1(){
        const styling = {
            fontFamily: 'Dyslexia'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function DyslexiaFriendlyLevel2(){
        const styling = {
            fontFamily: 'Arial, serif'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }

    /*------------------------------
      Cursor Operations
    --------------------------------*/
    function CursorLevel0(){
        const a = document.querySelector('.engyj-cursor-level3')
        if(document.body.contains(a)) a.remove()
    }
    function CursorLevel1(){
        body.classList += " engyj-big-cursor";
    }
    function CursorLevel2(){
        body.classList.remove("engyj-big-cursor")
            
        if(document.querySelectorAll(".engyj-exception.top").length === 0){
            let topDiv =  document.createElement('div');
            let bottomDiv =  document.createElement('div');

            body.appendChild(topDiv);
            body.appendChild(bottomDiv);

            topDiv.className = 'engyj-exception top'
            bottomDiv.className = 'engyj-exception bottom'
        }

        body.addEventListener('mousemove', (e) => {

            const engyjTop = document.querySelector('.engyj-exception.top')
            const engyjBottom = document.querySelector('.engyj-exception.bottom')

            const th =  e.y - 60
            const tb = (window.innerHeight - e.y) - 60

            if(document.body.contains(engyjTop)) engyjTop.style.height = th+'px'
            if(document.body.contains(engyjBottom)) engyjBottom.style.height = tb+'px'

        })
    }
    function CursorLevel3(){

        const t = document.querySelector('.engyj-exception.top')
        const b = document.querySelector('.engyj-exception.bottom')
        if(document.body.contains(t)) t.remove()
        if(document.body.contains(b)) b.remove()

        if(document.querySelectorAll('.engyj-cursor-level3').length === 0){
            const cursorTooltipDiv = document.createElement('div');
            body.appendChild(cursorTooltipDiv)
            cursorTooltipDiv.className = "engyj-cursor-level3"

            const cursorTooltipArrowDiv = document.createElement('div');
            document.querySelector('.engyj-cursor-level3').appendChild(cursorTooltipArrowDiv)
            cursorTooltipArrowDiv.className = "engyj-cursor-level3-arrow"
        }

        body.addEventListener('mousemove', (e) => {
            const cursorLevel3Div        =  document.querySelector('.engyj-cursor-level3')
            // const cursorLevel3ArrowDiv   =  document.querySelector('.engyj-cursor-level3-arrow')
            
            let calculateCursorVW = (window.innerWidth * 40) / 100
            calculateCursorVW = calculateCursorVW / 2

            console.log(calculateCursorVW);
            
            if(document.body.contains(cursorLevel3Div)) cursorLevel3Div.style.left = e.pageX +'px'
            if(document.body.contains(cursorLevel3Div)) cursorLevel3Div.style.top = e.pageY - 20 +'px'
            
            // cursorLevel3ArrowDiv.style.left = e.x+'px'
            // cursorLevel3ArrowDiv.style.top = e.y+'px'

        })
    }

    /*------------------------------
      Line Height Operations
    --------------------------------*/
    function LineHeightLevel0(){
        const styling = { lineHeight: "" }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function LineHeightLevel1(){
        const styling = { lineHeight: "37.5px" }
        
        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function LineHeightLevel2(){
        const styling = { lineHeight: "43.75px" }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function LineHeightLevel3(){
        const styling = { lineHeight: "50px" }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }

    /*------------------------------
      Text Align Operations
    --------------------------------*/
    function TextAlignLevel0(){
        const styling = {
            textAlign: '',
            // display: '',
            // width:''
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function TextAlignLevel1(){
        const styling = {
            textAlign: 'left'
            // display: 'block',
            // width:'100%'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function TextAlignLevel2(){
        const styling = {
            textAlign: 'right'
            // display: 'block',
            // width:'100%'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function TextAlignLevel3(){
        const styling = {
            textAlign: 'center'
            // display: 'block',
            // width:'100%'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }
    function TextAlignLevel4(){
        const styling = {
            textAlign: 'justify'
            // display: 'block',
            // width:'100%'
        }

        for(let i=0; i < webBody.length; i++){
            helperFilterTextElementAndApplyStyle(webBody[i], '', styling)
        }
    }

    /*------------------------------
      Move Hide Icon Operations
    --------------------------------*/
    function MoveHideIconLevel0(){
        html.classList.remove('MoveHidePosition1')
        document.querySelectorAll('.moveText').textContent = 'Move Left'
    }
    function MoveHideIconLevel1(){
        html.classList += ' MoveHidePosition1'
        document.querySelectorAll('.moveText').textContent = 'Move Right'
    }


    /*========================
     Handler Functions
    ======================*/

    const handlerScreenRead = (e) => {
        
        if(stateScreenRead === 'position0') { 
            
            setStateScreenRead('position1')
            for(let i = 11; i < webBody.length; i++){
                webBody[i].setAttribute("tabindex", -1)
            }

            for(let i = 11; i < webBody.length; i++){
                webBody[i].setAttribute("tabindex", i)
            }


        
        }

        if(stateScreenRead === 'position1') { 
            
            setStateScreenRead('position2')
        
        }

        if(stateScreenRead === 'position2'){
            
            setStateScreenRead('position3')

        }

        if(stateScreenRead === 'position3'){ 
            
            setStateScreenRead('position0')

        }

    }

    const handlerContrast = (e) => {

        if(stateContrast === 'position0'){

            setStateContrast('position1') 
            localStorage.setItem("setStateContrast", 'position1')
            contrastLevel1()

        }

        if(stateContrast === 'position1'){ 

            setStateContrast('position2')
            localStorage.setItem("setStateContrast", 'position2')
            contrastLevel2()

        }

        if(stateContrast === 'position2'){

            setStateContrast('position3')
            localStorage.setItem("setStateContrast", 'position3')
            contrastLevel3()

        }

        if(stateContrast === 'position3'){ 

            setStateContrast('position4')
            localStorage.setItem("setStateContrast", 'position4')
            contrastLevel4()

        }
        
        if(stateContrast === 'position4'){

            setStateContrast('position0')
            localStorage.setItem("setStateContrast", 'position0')
            contrastLevel0()

        }
    }

    const handlerSmartContrast = (e) => {
        if(stateSmartContrast === 'position0') setStateSmartContrast('position1')
        if(stateSmartContrast === 'position1') setStateSmartContrast('position0')
    }

    const handlerHighlightLinks = (e) => {
        
        if(stateHighlightLinks === 'position0'){
         
            setStateHighlightLinks('position1')
            localStorage.setItem("setStateHighlightLinks", 'position1')
            HighlightLinksLevel1()
        
        }
        
        if(stateHighlightLinks === 'position1'){
            
            setStateHighlightLinks('position0')
            localStorage.setItem("setStateHighlightLinks", 'position0')
            HighlightLinksLevel0()
            
        }

    }
    
    const handlerBiggerText = (e) => {

        if(stateBiggerText === 'position0'){ 

            setStateBiggerText('position1')
            localStorage.setItem("setStateBiggerText", 'position1')
            BiggerTextLevel1()
        }

        if(stateBiggerText === 'position1'){ 
            
            setStateBiggerText('position2')
            localStorage.setItem("setStateBiggerText", 'position2')
            BiggerTextLevel2()
        }

        if(stateBiggerText === 'position2'){ 

            setStateBiggerText('position3') 
            localStorage.setItem("setStateBiggerText", 'position3')
            BiggerTextLevel3()
        }

        if(stateBiggerText === 'position3'){
            
            setStateBiggerText('position4')
            localStorage.setItem("setStateBiggerText", 'position4')
            BiggerTextLevel4()
        }

        if(stateBiggerText === 'position4'){ 
            
            setStateBiggerText('position0')
            localStorage.setItem("setStateBiggerText", 'position0')
            BiggerTextLevel0()
        
        }

    }

    const handlerTextSpacing = (e) => {
        
        if(stateTextSpacing === 'position0'){ 

            setStateTextSpacing('position1')
            localStorage.setItem("setStateTextSpacing", 'position1')
            TextSpacingLevel1()

        }
        if(stateTextSpacing === 'position1'){
        
            setStateTextSpacing('position2')
            localStorage.setItem("setStateTextSpacing", 'position2')
            TextSpacingLevel2()
        
        }
        if(stateTextSpacing === 'position2'){
            
            setStateTextSpacing('position3')
            localStorage.setItem("setStateTextSpacing", 'position3')
            TextSpacingLevel3()

        }
        if(stateTextSpacing === 'position3'){ 
            
            setStateTextSpacing('position0')
            localStorage.setItem("setStateTextSpacing", 'position0')
            TextSpacingLevel0()
            
        }
    }

    const handlerPauseAnimation = (e) => {
        
        if(statePauseAnimation === 'position0'){
        
            setStatePauseAnimation('position1')
            localStorage.setItem("setStatePauseAnimation", 'position1')
            PauseAnimationLevel1()
        
        }

        if(statePauseAnimation === 'position1'){
            
            setStatePauseAnimation('position0')
            localStorage.setItem("setStatePauseAnimation", 'position0')
            PauseAnimationLevel0()

        }

    }
    
    const handlerDyslexiaFriendly = (e) => {

        if(stateDyslexiaFriendly === 'position0'){ 
            
            setStateDyslexiaFriendly('position1')
            localStorage.setItem("setStateDyslexiaFriendly", 'position1')
            DyslexiaFriendlyLevel1()

        }

        if(stateDyslexiaFriendly === 'position1'){
            
            setStateDyslexiaFriendly('position2')
            localStorage.setItem("setStateDyslexiaFriendly", 'position2')
            DyslexiaFriendlyLevel2()
        }

        if(stateDyslexiaFriendly === 'position2'){
            
            setStateDyslexiaFriendly('position0')
            localStorage.setItem("setStateDyslexiaFriendly", 'position0')
            DyslexiaFriendlyLevel0()
        
        }

    }

    const handlerCursor = (e) => {
        
        if(stateCursor === 'position0'){
            
            setStateCursor('position1')
            localStorage.setItem("setStateCursor", 'position1')
            CursorLevel1()
            
        }

        if(stateCursor === 'position1'){
            
            setStateCursor('position2')
            localStorage.setItem("setStateCursor", 'position2')
            CursorLevel2()

        }

        if(stateCursor === 'position2'){ 
            
            setStateCursor('position3')
            localStorage.setItem("setStateCursor", 'position3')
            CursorLevel3()

        }

        if(stateCursor === 'position3'){
            
            setStateCursor('position0')
            localStorage.setItem("setStateCursor", 'position0')
            CursorLevel0()
        
        }

    }

    const handlerTooltips = (e) => {
        if(stateTooltips === 'position0') setStateTooltips('position1')
        if(stateTooltips === 'position1') setStateTooltips('position0')
    }

    const handlerPageStructure = (e) => {
        if(statePageStructure === 'position0') setStatePageStructure('position1')
        if(statePageStructure === 'position1') setStatePageStructure('position0')
    }

    const handlerLineHeight = (e) => {

        if(stateLineHeight === 'position0'){ 
            
            setStateLineHeight('position1')
            localStorage.setItem("setStateLineHeight", 'position1')
            LineHeightLevel1()

        }

        if(stateLineHeight === 'position1'){

            setStateLineHeight('position2')
            localStorage.setItem("setStateLineHeight", 'position2')
            LineHeightLevel2()
        
        }

        if(stateLineHeight === 'position2'){ 

            setStateLineHeight('position3')
            localStorage.setItem("setStateLineHeight", 'position3')
            LineHeightLevel3()
        
        }

        if(stateLineHeight === 'position3'){

            setStateLineHeight('position0')
            localStorage.setItem("setStateLineHeight", 'position0')
            LineHeightLevel0()

        }

    }

    const handlerTextAlign = (e) => {
        
        if(stateTextAlign === 'position0'){ 
        
            setStateTextAlign('position1')
            localStorage.setItem("setStateTextAlign", 'position1')
            TextAlignLevel1()
        
        }

        if(stateTextAlign === 'position1'){ 
        
            setStateTextAlign('position2')
            localStorage.setItem("setStateTextAlign", 'position2')
            TextAlignLevel2()
        
        }

        if(stateTextAlign === 'position2'){
        
            setStateTextAlign('position3')
            localStorage.setItem("setStateTextAlign", 'position3')
            TextAlignLevel3()

        }
        if(stateTextAlign === 'position3'){
            
            setStateTextAlign('position4')
            localStorage.setItem("setStateTextAlign", 'position4')
            TextAlignLevel4()

        } 
        
        if(stateTextAlign === 'position4'){
            
            setStateTextAlign('position0')
            localStorage.setItem("setStateTextAlign", 'position0')
            TextAlignLevel0()

        } 
    }

    const handlerReadingFlow = (e) => {
        if(stateReadingFlow === 'position0') setStateReadingFlow('position1')
        if(stateReadingFlow === 'position1') setStateReadingFlow('position2')
        if(stateReadingFlow === 'position2') setStateReadingFlow('position3')
        if(stateReadingFlow === 'position3') setStateReadingFlow('position4')
        if(stateReadingFlow === 'position4') setStateReadingFlow('position0')
    }

    const handlerMoveHideIcon = (e) => {

        if(stateMoveHideIcon === 'position0'){

            setStateMoveHideIcon('position1') 
            localStorage.setItem("setStateMoveHideIcon", 'position1')
            MoveHideIconLevel1()

        }

        if(stateMoveHideIcon === 'position1'){ 

            setStateMoveHideIcon('position0')
            localStorage.setItem("setStateMoveHideIcon", 'position0')
            MoveHideIconLevel0()

        }

    }

    const handlerReset = (e) => {
        setStateScreenRead('position0')
        setStateContrast('position0')
        setStateSmartContrast('position0')
        setStateHighlightLinks('position0')
        setStateBiggerText('position0')
        setStateTextSpacing('position0')
        setStatePauseAnimation('position0')
        setStateDyslexiaFriendly('position0')
        setStateCursor('position0')
        setStateTooltips('position0')
        setStatePageStructure('position0')
        setStateLineHeight('position0')
        setStateTextAlign('position0')
        setStateReadingFlow('position0')
        setStateMoveHideIcon('position0') 
        helperUndoAll()

        localStorage.setItem("setStateScreenRead", 'position0')
        localStorage.setItem("setStateContrast", 'position0')
        localStorage.setItem("setStateSmartContrast", 'position0')
        localStorage.setItem("setStateHighlightLinks", 'position0')
        localStorage.setItem("setStateBiggerText", 'position0')
        localStorage.setItem("setStateTextSpacing", 'position0')
        localStorage.setItem("setStatePauseAnimation", 'position0')
        localStorage.setItem("setStateDyslexiaFriendly", 'position0')
        localStorage.setItem("setStateCursor", 'position0')
        localStorage.setItem("setStateTooltips", 'position0')
        localStorage.setItem("setStatePageStructure", 'position0')
        localStorage.setItem("setStateLineHeight", 'position0')
        localStorage.setItem("setStateTextAlign", 'position0')
        localStorage.setItem("setStateReadingFlow", 'position0')
        localStorage.setItem("setStateMoveHideIcon", 'position0')
    }
    
    return(
        <div className="container-content">
            <div>
                {/* <div tabIndex="1000001" aria-label="Screen Reader On" role="button" className="action" target={stateScreenRead} onClick={handlerScreenRead}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-screen-read icon-screen-position"></span>
                        </div>
                        <span>Screen Reader</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                        </div>
                    </div>
                </div> */}
                <div tabIndex="1000002" aria-label="Contrast Plus On" role="button" className="action" target={stateContrast} onClick={handlerContrast}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-contrast icon-contrast-position"></span>
                        </div>
                        <span>Contrast +</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                            <div className="step4"></div>
                        </div>
                    </div>
                </div>
                {/* <div role="button" className="action" target={stateSmartContrast} onClick={handlerSmartContrast}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-smart-contrast icon-smart-contrast-position"></span>
                        </div>
                        <span>Smart Contrast</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div> */}
                <div tabIndex="1000003" aria-label="Highlight Links On" role="button" className="action" target={stateHighlightLinks} onClick={handlerHighlightLinks}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-highlight-links icon-highlight-links-position"></span>
                        </div>
                        <span>Highlight Links</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div>
                <div tabIndex="1000004" aria-label="Bigger Text On" role="button" className="action" target={stateBiggerText} onClick={handlerBiggerText}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-bigger-text icon-bigger-text-position"></span>
                        </div>
                        <span>Bigger Text</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                            <div className="step4"></div>
                        </div>
                    </div>
                </div>
                <div tabIndex="1000005" aria-label="Text Spacing On" role="button" className="action" target={stateTextSpacing} onClick={handlerTextSpacing}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-text-spacing icon-text-spacing-position"></span>
                        </div>
                        <span>Text Spacing</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                        </div>
                    </div>
                </div>
                <div tabIndex="1000006" aria-label="Pause Animations On" role="button" className="action" target={statePauseAnimation} onClick={handlerPauseAnimation}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-pause-animation icon-pause-animation-position"></span>
                        </div>
                        <span>Pause Animations</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div>
                <div tabIndex="1000007" aria-label="Dyslexia Friendly On" role="button" className="action" target={stateDyslexiaFriendly} onClick={handlerDyslexiaFriendly}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${ImageSprite}")`}} className="svg-sprite icon-dyslexia-friendly icon-dyslexia-friendly-position"></span>
                        </div>
                        <span>Dyslexia Friendly</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                        </div>
                    </div>
                </div>
                <div tabIndex="1000008" aria-label="Cursor On" role="button" className="action" target={stateCursor} onClick={handlerCursor}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-cursor icon-cursor-position"></span>
                        </div>
                        <span>Cursor</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                        </div>
                    </div>
                </div>
                {/* <div role="button" className="action" target={stateTooltips} onClick={handlerTooltips}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-tooltips icon-tooltips-position"></span>
                        </div>
                        <span>Tooltips</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div> */}
                {/* <div role="button" className="action" target={statePageStructure} onClick={handlerPageStructure}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-page-structure icon-page-structure-position"></span>    
                        </div>
                        <span>Page Structure</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div> */}
                <div tabIndex="1000009" aria-label="Line Height On" role="button" className="action" target={stateLineHeight} onClick={handlerLineHeight}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-line-height icon-line-height-position"></span> 
                        </div>
                        <span>Line Height</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                        </div>
                    </div>
                </div>
                <div tabIndex="10000010" aria-label="Text Align On" role="button" className="action" target={stateTextAlign} onClick={handlerTextAlign}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-text-align icon-text-align-position"></span> 
                        </div>
                        <span>Text Align</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                            <div className="step4"></div>
                        </div>
                    </div>
                </div>
                {/* <div role="button" className="action" target={stateReadingFlow} onClick={handlerReadingFlow}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${IconEngyj}")`}} className="svg-sprite icon-reading-flow icon-reading-flow-position"></span> 
                        </div>
                        <span>Reading Flow</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                        <div className="level-wrapper">
                            <div className="step1"></div>
                            <div className="step2"></div>
                            <div className="step3"></div>
                            <div className="step4"></div>
                        </div>
                    </div>
                </div> */}
                <div tabIndex="10000011" aria-label="Move Left On" role="button" className="action" target={stateMoveHideIcon} onClick={handlerMoveHideIcon}>
                    <div>
                        <div className="icon-wrapper">
                            <span style={{backgroundImage:`url("//ada.engyj.com/0.1/${ImageSprite}")`}} className="svg-sprite icon-move icon-move-position"></span> 
                        </div>
                        <span className="moveText">Move Left</span>
                        <div className="check">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.03125 2.0625C3.40626 0.687493 5.06249 0 7 0C8.93751 0 10.5885 0.682285 11.9531 2.04688C13.3177 3.41147 14 5.06249 14 7C14 8.93751 13.3177 10.5885 11.9531 11.9531C10.5885 13.3177 8.93751 14 7 14C5.06249 14 3.41147 13.3177 2.04688 11.9531C0.682285 10.5885 0 8.93751 0 7C0 5.06249 0.677077 3.41667 2.03125 2.0625ZM10.5938 4.65625C10.6146 4.63542 10.625 4.60417 10.625 4.5625C10.625 4.5 10.6146 4.45833 10.5938 4.4375L9.625 3.6875C9.60417 3.66667 9.5625 3.65625 9.5 3.65625C9.45833 3.65625 9.42708 3.66667 9.40625 3.6875L5.9375 8.15625C5.02083 7.28125 4.55208 6.83333 4.53125 6.8125C4.46875 6.75 4.40625 6.71875 4.34375 6.71875C4.32292 6.71875 4.28125 6.75 4.21875 6.8125L3.40625 7.625C3.38542 7.64583 3.375 7.6875 3.375 7.75C3.375 7.79167 3.38542 7.82292 3.40625 7.84375L3.46875 7.875C5.09376 9.43751 5.91667 10.2292 5.9375 10.25C6 10.3125 6.05208 10.3438 6.09375 10.3438C6.13542 10.3438 6.1875 10.3125 6.25 10.25L10.5938 4.65625Z" fill="#4e5d9d"></path></svg>
                        </div>
                    </div>
                </div>
                <div tabIndex="10000012" aria-label="Reset All" role="button" className="action reset w-100" onClick={handlerReset}>
                    <div>Reset All</div>
                </div>
                {/* <div role="button" className="action move hide">
                    <div>Move/Hide</div>
                </div> */}
            </div>
        </div>
    )
}

export default WidgetContent